/*eslint-disable*/ export const messages = { New: "Nuevo", "Remove {label}": ["Eliminar ", ["label"]] };
